/* eslint-disable max-len */
import React from 'react'; // { useEffect, useState }
import { FaTimes, FaQuestionCircle } from 'react-icons/fa';
import useTranslation from '../../hooks/useTranslation';
import EpButton from '../EpButton';
import EpModal, { handleToggleModal } from '../EpModal';
import './styles.scss';

export default function EpHelpModal() {
  // Tags do Globalization
  const Help = useTranslation('Help');
  const WhatIsEpimedMonitor = useTranslation('What is Epimed Monitor Integration?');
  const WhatIsEpimedMonitorAnswer = useTranslation("It is a system directed to the hospitals' IT teams that has integration with Epimed Monitor, which shows the received data and its processing results.");
  const AdvantagesOfEpimedMonitor = useTranslation('What are the advantages of Epimed Monitor Integration for our client?');
  const AdvantagesOfEpimedMonitorAnswer = useTranslation('They will have the following advantages: detailing of the data received by the integration and how it was processed; visualizing of possible error logs recorded during processing; monitoring of the relationship between "sent data x used data" and trust and clarity about the use of the data received.');
  const WhichInformationWillBeVisualized = useTranslation('Which information will be visualized in Epimed Monitor Integration?');
  const WhichInformationWillBeVisualizedAnswer = useTranslation('The user may view the dates on which data was received; the dates on which data was processed; check if the data was used for integration with Epimed Monitor, and, in case one of the data was not used, may view the error log and its description. Besides many other fields that may help monitoring sent and processed data.');
  const MainResourcesAvailable = useTranslation('What are the main resources available for Epimed Monitor Integration usability?');
  const MainResourcesAvailableAnswer1 = useTranslation('1. The user will be able to search the data separated by integration type, being possible to filter the donors by: period, hospital and hospital admission number. In addition, for the Patient Flow integration, it is also possible to filter by patient ID.');
  const MainResourcesAvailableAnswer2 = useTranslation('2. You can define the result columns you want to see by clicking the Columns icon in the upper right corner and then selecting or deselecting them.');
  const MainResourcesAvailableAnswer3 = useTranslation('3. The user can select the amount of results you want to analyze per page, selecting from 25 to 100 results, in the lower left corner of the screen.');
  const MainResourcesAvailableAnswer4 = useTranslation('4. In the column Integration Status, you can follow up if the data was processed or not by the integration with Epimed Monitor.');
  const MainResourcesAvailableAnswer5 = useTranslation('5. In cases of non-processing of data, it is possible to check the errors that occurred in the Error Count column and more details of the error logs in the Options column. By clicking on the "..." icon and accessing the Error Description History.');
  const Close = useTranslation('Close');

  const headerTitle = (
    <span> <FaQuestionCircle className="btn__icon help-modal__title-icon" /> {Help}</span>
  );

  const bodyContent = (
    <div className="help-modal__subtitle">
      <div className="help-modal__subtitle--primary">
        <span>{WhatIsEpimedMonitor}</span>
        <p>{WhatIsEpimedMonitorAnswer}</p>
      </div>

      <div className="help-modal__subtitle--secondary">
        <span>{AdvantagesOfEpimedMonitor}</span>
        <p>{AdvantagesOfEpimedMonitorAnswer}</p>
      </div>

      <div className="help-modal__subtitle--secondary">
        <span>{WhichInformationWillBeVisualized}</span>
        <p>{WhichInformationWillBeVisualizedAnswer}</p>
      </div>

      <div className="help-modal__subtitle--secondary">
        <span>{MainResourcesAvailable}</span>
        <p>{MainResourcesAvailableAnswer1}</p>
        <p>{MainResourcesAvailableAnswer2}</p>
        <p>{MainResourcesAvailableAnswer3}</p>
        <p>{MainResourcesAvailableAnswer4}</p>
        <p>{MainResourcesAvailableAnswer5}</p>

      </div>
    </div>
  );

  const footerContent = (
    <EpButton
      actionType="button"
      labelText={Close}
      // TODO: Limpar campo de seleção de idioma
      linkFunc={() => handleToggleModal('modal--integrations-help')}
      buttonType="secondary-outline"
      buttonIcon={<FaTimes className="btn__icon" />}
      customClass="btn__footer"
      disabled={false}
    />
  );

  return (
    <EpModal
      modalId="modal--integrations-help"
      headerTitle={headerTitle}
      bodyContent={bodyContent}
      footerContent={footerContent}
      size="lg"
      alignFooter="justify-content-end"
    />
  );
}
